import { Button } from "@mui/material";
import LoadingSpinner from "components/LoadingSpinner";
import React from "react";
import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";

const DownloadLetterTemplateModal = ({
  isModalOpen,
  onClose,
  isLoading,
  onDownload,
}) => {
  return (
    <ModalWrapper
      open={isModalOpen}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      title="Letter Generated"
    >
      <div>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            <div className="mt-2 generate-template-modal__content">
              <p>
                You can find the generated letter in the documents list. Do you
                want to download the letter?
              </p>
            </div>

            <div className="mt-2 generate-template-modal__footer">
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => onClose()}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#94ba33",
                  color: "white",
                }}
                onClick={onDownload}
              >
                Download
              </Button>
            </div>
          </>
        )}
      </div>
    </ModalWrapper>
  );
};

export default DownloadLetterTemplateModal;
